export type TokenBalanceStorage = {
    symbol: 'Balance' | 'bal';
    storage: 'persistent' | 'instance' | 'persistentWithInstanceFallback';
};

// SEP-41 specifies balance(), not its storage layout. Only reviewed WASM builds
// belong here; a familiar key or one matching simulation is not sufficient.
// The live instance hash is checked on every read, including after upgrades.
// Review notes and read-only verification: scripts/verify-token-balances.cjs.
export const TOKEN_BALANCE_STORAGE: Readonly<Record<string, TokenBalanceStorage>> = {
    // ARKAT: instance [bal, owner] -> i128.
    '0b1ac970e54a2ee40f7bef0e2226f022d0b8551d331b1b2df12a7a1dfb705ac0': {
        symbol: 'bal',
        storage: 'instance',
    },
    f8a20336f40eabb1a1571078cf4efcfe46a568c833283fefea158b9a2138d379: {
        symbol: 'bal',
        storage: 'instance',
    },
    // ARKAT migration builds: persistent first, then the legacy instance entry.
    e0582975a6daa24ad5b542d266215af6ecd4621a154c38b01219eae00a6d5b49: {
        symbol: 'bal',
        storage: 'persistentWithInstanceFallback',
    },
    '485b49046dd6e28b81a63f1aa347472d3e235937eb7092db225233ef653786c2': {
        symbol: 'bal',
        storage: 'persistentWithInstanceFallback',
    },
    // Simple persistent [Balance, owner] -> i128 accessors (no rebasing).
    // Testnet SOR18/SOR18Cheap and TKA/TKB.
    '464c7cf3fb3cd426e700973c98ae63dee903e83d411491b691dad72c035dcd7d': {
        symbol: 'Balance',
        storage: 'persistent',
    },
    '72eb5d52c532e78ccc6c8a7f8523c458e03764074717172f69c2539e754ce624': {
        symbol: 'Balance',
        storage: 'persistent',
    },
    // Mainnet SolvBTC/xSolvBTC and bridged BTC/SOL/ETH.
    f11078394fd06b3992b4274611a7c47809707bdce61254cffa6dd40fcaad364f: {
        symbol: 'Balance',
        storage: 'persistent',
    },
    fd253afe4d354ed189b736247c356a5cca77ca21f97c21c676ea3d99684bff72: {
        symbol: 'Balance',
        storage: 'persistent',
    },
};
